import React from 'react';
import { Link } from 'react-router-dom';
import { CheckOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { FEATURE_MODULES } from '../constants/publicFeatures';
// Thème citron / noir / blanc de la page (classes préfixées "ft-")
import './Features.css';

// Étapes de prise en main
const STEPS = [
  { titre: 'Connectez WhatsApp', texte: 'Branchez votre fournisseur WhatsApp API (WhatChimp, WATI, WasenderAPI ou AiSensy) depuis les paramètres.' },
  { titre: 'Configurez votre activité', texte: 'Produits, zones de livraison, livreurs, modèles de message et équipe.' },
  { titre: 'Pilotez au quotidien', texte: 'Suivez commandes, livraisons, stocks et dépenses depuis le tableau de bord.' }
];

// Questions fréquentes (réponses alignées sur le fonctionnement réel de l'application)
const FAQ = [
  {
    question: 'Comment connecter mon numéro WhatsApp ?',
    reponse: 'Depuis les paramètres, connectez votre compte chez un fournisseur WhatsApp API parmi WhatChimp, WATI, WasenderAPI et AiSensy. Vos messages passent ensuite par ce fournisseur.'
  },
  {
    question: 'Que contient l\'essai gratuit ?',
    reponse: 'Pendant 14 jours, vous accédez aux fonctionnalités de l\'offre Essentiel avec les quotas de Découverte (20 messages, 15 commandes, 30 points IA offerts).'
  },
  {
    question: 'À partir de quelle offre la caisse (POS) est-elle disponible ?',
    reponse: 'La caisse, la gestion des caissiers, les campagnes marketing et le programme de fidélité sont inclus à partir de l\'offre Croissance.'
  },
  {
    question: 'À quoi servent les points IA ?',
    reponse: 'Ils alimentent l\'assistant commercial, les fiches produit et les images générées. Chaque offre inclut une enveloppe mensuelle, et vous pouvez acheter des points supplémentaires.'
  },
  {
    question: 'Puis-je gérer plusieurs boutiques ?',
    reponse: 'Oui. Chaque boutique dispose de ses propres données, de ses paramètres et de ses intégrations, et vous passez de l\'une à l\'autre depuis le même compte.'
  }
];

const Features = () => {
  return (
    <div className="ft-page">
      {/* Hero */}
      <section className="ft-hero">
        <span className="ft-pill">Fonctionnalités</span>
        <h1>Tout ce qu'il faut pour <span className="ft-mark">vendre et livrer</span></h1>
        <p>
          Commandes, livraisons, caisse, vitrine en ligne et assistant IA :
          découvrez ce que Mercuri Shop fait pour votre boutique.
        </p>
      </section>

      {/* Modules : une carte par module, générée depuis FEATURE_MODULES */}
      <section className="ft-modules">
        {FEATURE_MODULES.map((module) => (
          <article key={module.key} className="ft-module">
            <div className="ft-module-head">
              <span className="ft-icon">{module.icon}</span>
              <h2>{module.titre}</h2>
              {module.plan && <span className="ft-plan">À partir de l'offre {module.plan}</span>}
              <p>{module.resume}</p>
            </div>
            <ul>
              {module.details.map((detail) => (
                <li key={detail}><CheckOutlined /> {detail}</li>
              ))}
            </ul>
          </article>
        ))}
      </section>

      {/* Prise en main */}
      <section className="ft-steps">
        <h2>Prise en main</h2>
        <div className="ft-steps-grid">
          {STEPS.map((etape, index) => (
            <div key={etape.titre} className="ft-step">
              <span className="ft-num">{index + 1}</span>
              <h3>{etape.titre}</h3>
              <p>{etape.texte}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="ft-faq">
        <h2>Questions fréquentes</h2>
        <div className="ft-faq-list">
          {FAQ.map((item, index) => (
            <details key={item.question} open={index === 0}>
              <summary>{item.question}</summary>
              <p>{item.reponse}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Appel à l'action */}
      <section className="ft-cta">
        <h2>Prêt à essayer ?</h2>
        <p>14 jours d'essai gratuit avec les fonctionnalités de l'offre Essentiel.</p>
        <div>
          <Link to="/register" className="ft-btn ft-btn-accent">Essai gratuit 14 jours <ArrowRightOutlined /></Link>
          <Link to="/pricing" className="ft-btn ft-btn-light">Voir les tarifs</Link>
        </div>
      </section>
    </div>
  );
};

export default Features;
